import { notification as AntNotification } from 'antd';
export interface Error {
    errCode: string;
    errMsg: string;
}

export interface ErrorInfo {
    response: Response;
    status: string;
}

interface Response {
    body: BodyNode;
}
interface BodyNode {
    [x: string]: string;
}

export const errorHandle = (err: ErrorInfo, title?: string, duration?: number) => {
    let { response, status } = err;
    AntNotification.destroy();
    AntNotification.error({
        message: title || '出错啦',
        duration: duration || 2,
        description:
            status === undefined
                ? '请求已被终止。'
                : (response && response.body && response.body.err_message) || '请求失败',
    });
};
